import { useCallback, useState } from "react";
import { Product } from "../../../graphql/operations";
import WaitingListModal, { WaitingListModalProps } from "../WaitingListModal";

export type WaitingListButtonProps = {
  email?: string;
  onAdd?: () => void;
  phoneNumber?: string;
  productId?: Product["id"];
} & Pick<
  WaitingListModalProps,
  "productOptions" | "onAddWaitingList" | "timeZone"
> &
  Omit<React.HTMLAttributes<HTMLDivElement>, "onClick">;

export default function WaitingListButton({
  children,
  email,
  onAddWaitingList,
  phoneNumber,
  productId,
  productOptions,
  timeZone,
  ...divProps
}: React.PropsWithChildren<WaitingListButtonProps>) {
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = useCallback(() => setOpenModal(true), []);
  const handleCloseModal = useCallback(() => setOpenModal(false), []);

  return (
    <>
      <div {...divProps} onClick={handleOpenModal}>
        {children}
      </div>
      <WaitingListModal
        email={email}
        onAddWaitingList={onAddWaitingList}
        onClose={handleCloseModal}
        open={openModal}
        phoneNumber={phoneNumber}
        productId={productId}
        productOptions={productOptions}
        timeZone={timeZone}
      />
    </>
  );
}
